<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/receivableAdjustmentList' }">应收调整</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                    <draggableDetail :draggable="{ data_name: 'receivable_adjustment' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['principal_hierarchy'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="调整行" name="2">
                    <vReceivableAdjustmentLineListComponent v-if="flag" :postList="receivable_adjustment_line_params"></vReceivableAdjustmentLineListComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '@/components/common/DrawerDetail.vue';
import vReceivableAdjustmentLineListComponent from '../../listComponent/basicdata/receivableAdjustmentLine/receivableAdjustmentLineComponent.vue';
export default {
    inject: ['reload'],
    name: 'receivableAdjustmentDetail',
    components: {
        draggableDetail,
        vReceivableAdjustmentLineListComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '应收调整详情',
            flag: false,
            receivable_adjustment_line_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.receivable_adjustment_line_params.params = {
                receivable_adjustment_rid: this.queryParams.rid
            };
        },
        toDetail(prop) {
            if (prop == 'principal_hierarchy' && this.data.principal_hierarchy_rid) {
                this.$router.push({
                    path: '/hierarchyDetail',
                    query: {
                        id: this.data.principal_hierarchy_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).receivable_adjustment;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'receivableAdjustmentDelete', this.data.name, 'receivableAdjustmentList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'receivableAdjustmentEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'receivableAdjustmentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'receivableAdjustmentEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .receivableAdjustmentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>